import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRole } from '../auth/models/auth.models';
import { AuthService } from '../auth/services/auth.service';

function toAllowedRoles(route: ActivatedRouteSnapshot): UserRole[] {
  const roles = route.data['roles'];
  if (!Array.isArray(roles)) {
    return [];
  }

  return roles.filter(
    (role): role is UserRole => role === 'admin' || role === 'dekalb' || role === 'partner',
  );
}

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowedRoles = toAllowedRoles(route);
  if (!allowedRoles.length) {
    return true;
  }

  const role = authService.role();
  if (role && allowedRoles.includes(role)) {
    return true;
  }

  return router.createUrlTree(['/home']);
};
